import './global/js/util/modernizr';
import './global/js/util/polyfills';
import './style.scss';
import './global/js/core/core';

/*
 * Animations
 */
import accordionMobileInit from './global/js/accordions/accordion-mobile-init';
import cursorEffects from './global/js/animations/cursor-effects';
import staggerAnimation from './global/js/animations/gsap/stagger-text';
import numberCount from './global/js/animations/number-count';
import parallaxScroll from './global/js/animations/parallax-light';
import progressBar from './global/js/animations/progress';
import sectionColorThemeToggler from './global/js/animations/section-color-theme-toggler';
import letterEffects from './global/js/animations/splittext';
import accordionInit from './global/js/misc/accordion/accordion-init';
/*
 * Misc
 */
import dropdownInit from './global/js/misc/dropdown/dropdown-init';
import externalLinks from './global/js/misc/external-links/external-links';
import customMicromodalCall from './global/js/misc/micromodal/micromodal';
import stickyInit from './global/js/misc/sticky/sticky-init';
import swiperInit from './global/js/misc/swiper/swiper-init';
import tableInit from './global/js/misc/table/table-init';
import videoInit from './global/js/misc/video/video-init';
import initCookieBanner from './patterns/01-atoms/misc/cookie-banner/cookie-banner';
/*
 * Atoms
 */
import scrollToTop from './patterns/01-atoms/misc/scroll-to-top-a/scroll-to-top-a-1/scroll-to-top-a-1';
/*
 * Molecules
 */
import multiselectDropdown from './patterns/02-molecules/dropdowns/terms-multiselect-a/terms-multiselect-a-1/terms-multiselect-a-1';
import galleryA from './patterns/02-molecules/galleries/gallery-a/gallery-a-1/gallery-a-1';
import mapBlock from './patterns/02-molecules/maps/map-a/map-a-1';
import modal from './patterns/02-molecules/modals/modal-a/modal-a-1';
import modalVideoA1 from './patterns/02-molecules/modals/modal-video-a/modal-video-a-1';
import hamburger from './patterns/02-molecules/nav/hamburger-a/hamburger-a-1/hamburger-a-1';
import toggleMobileNavigationDropdowns from './patterns/02-molecules/nav/nav-mobile-a/nav-mobile-a-1';
import postHeadingNavigationA1 from './patterns/02-molecules/nav/post-heading-navigation-a/post-heading-navigation-a-1.js';
import searchBar from './patterns/02-molecules/search/search-bar-a/search-bar-a-1/search-bar-a-1';
import slideOut from './patterns/02-molecules/slide-outs/slide-out-a/slide-out-a-1/slide-out-a-1';
import socialShare from './patterns/02-molecules/social/social-share-a/social-share-a-1';
import filterType1 from './patterns/03-organisms/repeatable-custom/filter-a/filter-a-1/filter-a-1';
import latestPostsB1 from './patterns/03-organisms/repeatable-custom/latest-posts-b/latest-posts-b-1/latest-posts-b-1';
import mediaListB from './patterns/03-organisms/repeatable-custom/media-list-b/media-list-b-1/media-list-b';
/*
 * Organisms
 */
import menuA1 from './patterns/03-organisms/repeatable-custom/menu-a/menu-a-1/menu-a-1';
import servicesA1 from './patterns/03-organisms/repeatable-custom/services-a/services-a-1/services-a-1';
import testimonialsC from './patterns/03-organisms/repeatable-custom/testimonials-c/testimonials-c-1/testimonials-c-1';
import articleSingle3 from './patterns/03-organisms/single/article-single/article-single-3/article-single-3';
import footer from './patterns/03-organisms/single/footer/footer-1/footer';
import headerInit from './patterns/03-organisms/single/header/header-init';
/*
 * Plop Entry (do not remove)
 */
/// /DO NOT ERASE OR PLOP IMPORTING WILL FAIL
/// /IMPORT FROM PLOP

/*
 * Module Caller
 *
 * functions below are only run if the component exists (verified through a "data-module" in the html)
 * in the ajax container or page. Barba.js instantiates the functions below on container reload as well.
 *
 * Place in alphabetical order
 */
const modules = {
    searchBar,
    scrollToTop,
    socialShare,
    hamburger,
    slideOut,
    footer,
    modal,
    modalVideoA1,
    mapBlock,
    galleryA,
    filterType1,
    multiselectDropdown,
    progressBar,
    postHeadingNavigationA1,
    menuA1,
    articleSingle3,
    testimonialsC,
    mediaListB,
    servicesA1,
    latestPostsB1,
    initCookieBanner,
    /// /DO NOT ERASE OR PLOP IMPORTING WILL FAIL
    /// /MODULES FROM PLOP
};

/*
 * Fire JavaScript functions by if the associated "data-module" exists on the page.
 */
const calledModulesNames = [];
modules.instantiate = function (elem) {
    const module = elem.dataset.module;

    if (module === undefined) {
        throw 'Module not defined (use data-module="")';
    } else if (module in modules) {
        if (elem.dataset.initialized === 'true') {
            return;
        }
        new modules[module](elem);
        elem.dataset.initialized = true;
    } else {
        throw `Module '${module}' not found`;
    }
};

window.onload = (event) => {
    externalLinks();
    customMicromodalCall();

    headerInit();
    dropdownInit();
    swiperInit();
    tableInit();
    accordionInit();
    accordionMobileInit();

    staggerAnimation();
    toggleMobileNavigationDropdowns();
    stickyInit();
    /*
     * Loops through component functions that should only run if the component exists in the ajax container or page.
     * The actual check is performed through "data-module";
     */

    document.querySelectorAll('[data-module]').forEach(function (el) {
        if (calledModulesNames.indexOf(el.dataset.module) === -1) {
            modules.instantiate(el);
            calledModulesNames.push(el.dataset.module);
        }
    });

    modal();
    videoInit();
    numberCount();

    /*
     * GSAP based animations. Hide if not used.
     */
    // cursorEffects($);
    sectionColorThemeToggler();
    letterEffects($);
};

document.addEventListener('scroll', () => {
    parallaxScroll();
});
